<!--
  L'échéance des tableaux repris du mail (echeance) : dépassée en rouge, sous
  15 jours en orange. Un dépôt démantelé n'a plus d'échéance : on dit depuis
  quand il est fermé — « 291 j de retard » se lisait comme un délai à tenir.
-->
<template>
  <hv-pill v-if="closedDays !== null && closedDays !== undefined" :label="`fermé depuis ${int(closedDays)} j`" />
  <span v-else-if="days === null || days === undefined" class="hv2-muted">{{ DASH }}</span>
  <hv-pill v-else-if="days < 0" tone="danger" :label="`${int(-days)} j de retard`" />
  <hv-pill v-else-if="days <= 15" tone="warn" :label="`${int(days)} j`" />
  <span v-else>{{ int(days) }} j</span>
</template>

<script>
import fmt from '../format'
import HvPill from './HvPill'

export default {
  name: 'HvDueCell',
  components: { HvPill },
  props: {
    days: { type: Number, default: null },
    closedDays: { type: Number, default: null }
  },
  computed: {
    DASH: () => fmt.DASH
  },
  methods: {
    int: fmt.int
  }
}
</script>
